module.exports = __webpack_public_path__ + "static/media/MetamaskLogo.92a73d44.png";